/** Coding agents the one-click install row offers Muggle Works for. */
export enum AgentInstallTargetEnum {
  CLAUDE_CODE_DESKTOP = "claude-code-desktop",
  CURSOR = "cursor",
  CODEX = "codex",
  ANTIGRAVITY = "antigravity",
}
